import { Card } from "components/ui/card";
import StatusChip from "components/ui/status-chip";
import { useTranslation } from "react-i18next";
import { Color } from "utils/theme";

export enum ConnectStatus {
  Online = "Online",
  Offline = "Offline",
}

interface Props {
  label: string;
  status: ConnectStatus;
  icon?: JSX.Element;
}

export const ConnectionStatus = ({ label, status }: Props) => {
  const { t } = useTranslation();

  return (
    <Card className="p-4">
      <div className="flex justify-between items-center">
        <div className="flex items-center">
          <StatusChip
            color={status === ConnectStatus.Online ? "green" : "red"}
          />
          <p
            className="ml-4 font-medium"
            style={{
              color: Color.White,
            }}
          >
            {label}
          </p>
        </div>
        <div className="flex justify-start">
          <span className="flex items-center">
            <p
              style={{
                color:
                  status === ConnectStatus.Online
                    ? Color.Gray[200]
                    : Color.Primary[500],
              }}
            >
              {status === ConnectStatus.Online
                ? t("common.connected")
                : t("common.not_connected")}
            </p>
          </span>
        </div>
      </div>
    </Card>
  );
};
